import React, {ReactElement} from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import {Link, useLocation} from 'react-router-dom';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

type AppDrawerItemProps = {
    icon: ReactElement
    label: string,
    route: string,
}

export const AppDrawerItem = (props: AppDrawerItemProps) => {
    const { icon, label, route } = props

    const location = useLocation();

    return (
        <ListItem disablePadding>
            <ListItemButton component={Link} to={route} selected={location.pathname === route}>
                <ListItemIcon>
                    {icon}
                </ListItemIcon>
                <ListItemText primary={label} />
            </ListItemButton>
        </ListItem>
    )
}